module.exports = __webpack_public_path__ + "img/team-1-2.ddacbdd6.jpeg";